import { styled } from '@a1s/ui';

export const DotGrid = styled('div', {
  backgroundImage: `url('data:image/svg+xml;utf8,<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h2v2H0z" fill="white" fill-opacity="0.24"/></svg>')`,
  backgroundPosition: '$sizes$sm',
});
